import { label, format } from '@/utils/number';
import lang from './lang';
export default {
  mixins: [lang],
  data() {
    return {
      adsBaseChartOptions: {
        chart: {
          type: 'line',
          polar: false,
          panning: true,
          pinchType: 'x',
          style: {
            fontFamily: 'IRANSans',
          },
        },
        title: {
          text: null,
        },
        tooltip: {
          split: true,
          crosshairs: true,
          pointFormat:
            '<span style="display: inline-flex; color:{series.color}">{point.y}</span>',
          valueDecimals: 0,
        },
        plotOptions: {
          series: {
            showInNavigator: true,
            animation: false,
            dataLabels: {},
          },
        },
      },
    };
  },
  computed: {
    baseChartOptions() {
      const isPersian = this.lang === 'fa';
      const align = isPersian ? 'right' : 'left';
      const font = isPersian ? 'IRANSans' : 'EnIRANSans';
      return {
        chart: {
          type: 'area',
          style: {
            fontFamily: font,
          },
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: true,
          style: {
            textAlign: align,
          },
          useHTML: true,
          pointFormat: isPersian
            ? '{series.name}: <b>{point.y}</b> <span style="color:{point.color}">\u25CF</span><br/>'
            : '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
        },
        legend: {
          rtl: isPersian,
        },
        plotOptions: {
          series: {
            fillOpacity: 0.4,
          },
          area: {
            stacking: 'normal',
          },
        },
      };
    },
  },

  methods: {
    priceAxisFormatter() {
      const self = this;

      return function fn() {
        if (self.defaultChartType === 'amount') {
          return `
          <span style="display: inline-flex; direction: ${self.dir}">
            ${label(this.value, self.$t('RIALS'), 0)}
          </span>
        `;
        }

        return this.axis.defaultLabelFormatter.call(this);
      };
    },

    tooltipFormatter() {
      const self = this;

      return function fn() {
        let overal = '';

        const entries = this.points.reduce(self.formatChartEntryMarkup, '');

        if (this.points.length > 1) {
          overal = `
          <tr>
            <td>
              <strong>Sum</strong>
            </td>
            <td>${format(this.points[0].total)}</td>
          </tr>
        `;
        }

        return `
          <table style="border-collapse: separate; border-spacing: 5px">
            <thead>
              <tr>
                <th colspan="2">
                  ${this.x}
                </th>
              </tr>
            </thead>
            <tbody>
              ${entries}
            </tbody>
            <tfoot>
              ${overal}
            </tfoot>
          </table>
      `;
      };
    },

    formatChartEntryMarkup(acc, entry) {
      return `
        ${acc}
        <tr>
          <td style="color: ${entry.series.color}">
            <strong> ${entry.series.name} </strong>
          </td>
          <td>
            ${format(entry.y)}
          </td>
        </tr>
      `;
    },
  },
};
